import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import { baseApi, diversityApi } from "../api/baseAPI";
import authReducer from "../slices/authSlice";
import feedReducer from "../slices/feedSlice";
// import clubhouseReducer from "../slices/clubhouseSlice";
import clubhouseReducer from "../slices/newClubhouseSlice";
import clubhouseDetailReducer from "../slices/clubhouseDetailSlice";
import searchReducer from "../slices/searchMembersSlice";
import mainInboxReducer from "../slices/mainInboxSlice";
import requestInboxReducer from "../slices/requestInboxSlice";
import chFeedSlice from "../slices/ChFeedSlice";
import applicantFilterSlice from "../slices/nonmember/applicantFilterSlice";
import notLoggedInSlice from "../slices/nonMemberSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth"],
};

const combinedReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [diversityApi.reducerPath]: diversityApi.reducer,
  auth: authReducer,
  feed: feedReducer,
  clubhouse: clubhouseReducer,
  chFeed: chFeedSlice,
  clubhouseDetail: clubhouseDetailReducer,
  search: searchReducer,
  mainInbox: mainInboxReducer,
  requestInbox: requestInboxReducer,
  notLoggedIn: notLoggedInSlice,
  applicantFilter: applicantFilterSlice,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "auth/removeCredentials") {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      baseApi.middleware,
      diversityApi.middleware
    ),
});

export let persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
